/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import Detail from './Detail/index'
import Download from './Download/index'
import LineChart from './LineChart/index'
import Pie from './Pie/index'
import React from 'react'
import TableContent from './TableContent/index'
import styles from './view.module.css'
import useIsBefore from 'Simple/hooks/useIsBefore'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Marketing/ReportTable/Content/Content/Content"
  
}) {
  let isBefore = useIsBefore()
  return (<React.Fragment
>
<div
  data-testid="Content.Vertical"
  data-view-path={viewPath}
 style={{'--o-1-Z1Yf8zk': isBefore ? 0 : 1}}
 className={`views-block ${styles.Vertical}`}
>
<div
  data-testid="Content.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<Download
  viewPath={`${viewPath}/Download`}
/>
<Pie
  viewPath={`${viewPath}/Pie`}
/>
</div>
<LineChart
  viewPath={`${viewPath}/LineChart`}
/>
<TableContent
  viewPath={`${viewPath}/TableContent`}
/>
</div>
<Detail
  viewPath={`${viewPath}/Detail`}
/>
{children}
</React.Fragment>)
}